var exports = {
  "K": "IconButton__Ca7-Q0",
  "p": "DisabledButton__zGEXLy",
};

module.exports = exports;
